import { render, staticRenderFns } from "./MULTIPLECHOICEB.vue?vue&type=template&id=b6e02f4a&scoped=true&lang=pug"
import script from "./MULTIPLECHOICEB.vue?vue&type=script&lang=js"
export * from "./MULTIPLECHOICEB.vue?vue&type=script&lang=js"
import style0 from "./MULTIPLECHOICEB.vue?vue&type=style&index=0&id=b6e02f4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e02f4a",
  null
  
)

export default component.exports